import { useLocation, useParams } from "react-router-dom";
import {
  LegajoTabsContext,
  LegajoTabsProvider,
} from "../../../context/LegajoTabsContext";
import LegajosFormPage from "./LegajosFormPage";

/**
 * LegajosWrapper.jsx
 * @description Componente wrapper para el formulario de legajos (Contenedor de la lógica).
 * @date 11-11-2025
 * @autor : Joaquin
 */
export default function LegajosWrapper() {
  const location = useLocation();
  const cuil = location.state?.cuil;
  return (
    <LegajoTabsProvider>
      <LegajosFormPage cuil={cuil} />
    </LegajoTabsProvider>
  );
}
